import { useCallback } from 'react';

import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';
import { useAnalyticsEvents } from '@atlaskit/analytics-next/useAnalyticsEvents';

import { DEFAULT_GAS_CHANNEL } from '../../../../constants';

export const useAnalytics: () => ((payload: AnalyticsEventPayload) => void)[] = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const fireAnalyticsEvent = useCallback(
		(payload: AnalyticsEventPayload): void => {
			createAnalyticsEvent(payload).fire(DEFAULT_GAS_CHANNEL);
		},
		[createAnalyticsEvent],
	);

	return [fireAnalyticsEvent];
};
